import React, { useState, useEffect } from 'react';
import { ReactComponent as Logo } from '../../images/showit-logo.svg';
import mainLogo from '../../images/showit-logo.png';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  ADD_POST,
  BOOKMARKS,
  HELP_SUPPORT,
  LIKEDPOSTS,
  LISTS,
  MESSAGES,
  NOTIFICATIONS,
  PROFILE,
  USER_PROFILE,
  ROOT,
  SETTINGS_ACCOUNT,
  SETTINGS_FINANCIAL,
  SETTINGS_PROFILE,
  SUBSCRIBERS,
  SUBSCRIPTIONS,
  CONTACT_US,
  PAYMENTS,
  ADD_CARD,
  ADD_BANK,
  BANK_ACCOUNT,
  CHOOSE_ARTWORK,
  SEARCH,
  SAVED_POSTS,
  EDIT_POST,
  TERMS_PRIVACY,
  SEND_MESSAGE,
  ACCOUNT_SUPPORT,
  ACCOUNT_SECURITY_SUPPORT,
  GENERAL_QUESTIONS_SUPPORT,
  PRIVACY_TERMS_SUPPORT,
  SUBSCRIPTION_FAQ,
  PAYMENT_FAQ,
  TIPS_FAQ,
  MY_WALLET_FAQ,
  VALUE_TAX_FAQ,
  BECOME_CREATOR_SUPPORT,
  CREATOR_ERNING_PAYOUTS_SUPPORT,
  CREATOR_TIPS_SUPPORT,
  CREATOR_ACC_SUPPORT,
  CREATOR_ACC_SET_SUPPORT,
  CREATOR_TAG_SUPPORT,
  CREATOR_PROMOTING_SUPPORT,
  CREATOR_REF_SUPPORT,
  CREATOR_TECH_SUPPORT,
  CREATOR_VALUE_SUPPORT,
  MENUSETTINGS,
  CREATOR_TAX_INF_SUPPORT,
  QUESTION_SUPPORT,
  SEARCH_SUPPORT,
  SINGLE_POST,
  CHANNELS,
  MEMBERS
} from '../../constants/routes';
import { BackIcon, BurgerMenuIcon, SearchIcon } from '../Icons';
import SearchBar from './SearchBar';
import GoBack from './GoBack';
import BurgerMenu from '../layout/BurgerMenu';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ activeItem, currentLocation, payment, user, ...rest }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const clickHandler = () => {
    history?.goBack();
  }

  const leftPartOptions = {
    searchIcon: {
      component: SearchBar,
      name: 'search',
      icon: SearchIcon,
      visibleOnScreens: [ROOT],
    },
    backIcon: {
      component: GoBack,
      name: 'go-back',
      icon: BackIcon,
      visibleOnScreens: [

       SINGLE_POST,
        NOTIFICATIONS,
        ADD_POST,
        BOOKMARKS,
        HELP_SUPPORT,
        LIKEDPOSTS,
        LISTS,
        SETTINGS_ACCOUNT,
        SETTINGS_FINANCIAL,
        SETTINGS_PROFILE,
        SUBSCRIBERS,
        SUBSCRIPTIONS,
        CONTACT_US,
        PAYMENTS,
        ADD_CARD,
        ADD_BANK,
        BANK_ACCOUNT,
        CHOOSE_ARTWORK,
        SEARCH,
        MENUSETTINGS,
        SAVED_POSTS,
        EDIT_POST,
        TERMS_PRIVACY,
        SEND_MESSAGE,
        PROFILE,
        USER_PROFILE,
        ACCOUNT_SUPPORT,
        ACCOUNT_SECURITY_SUPPORT,
        GENERAL_QUESTIONS_SUPPORT,
        PRIVACY_TERMS_SUPPORT,
        SUBSCRIPTION_FAQ,
        PAYMENT_FAQ,
        TIPS_FAQ,
        MY_WALLET_FAQ,
        VALUE_TAX_FAQ,
        BECOME_CREATOR_SUPPORT,
        CREATOR_ERNING_PAYOUTS_SUPPORT,
        CREATOR_TIPS_SUPPORT,
        CREATOR_ACC_SUPPORT,
        CREATOR_ACC_SET_SUPPORT,
        CREATOR_TAG_SUPPORT,
        CREATOR_PROMOTING_SUPPORT,
        CREATOR_REF_SUPPORT,
        CREATOR_TECH_SUPPORT,
        CREATOR_VALUE_SUPPORT,
        CREATOR_TAX_INF_SUPPORT,
        QUESTION_SUPPORT,
        SEARCH_SUPPORT,
        CHANNELS,
        MEMBERS
      ],
      clickHandler,
    },
  };

  const rightPartOptions = {
    save: {
      component: null,
      name: 'save',
      icon: null,
      visibleOnScreens: [],
    },
    burgerMenu: {
      component: BurgerMenu,
      name: 'burger-menu',
      icon: BurgerMenuIcon,
      visibleOnScreens: [
        ROOT,
        PROFILE,
        USER_PROFILE,
        MESSAGES,
        NOTIFICATIONS,
        ADD_POST,
        BOOKMARKS,
        HELP_SUPPORT,
        LIKEDPOSTS,
        LISTS,
        SETTINGS_ACCOUNT,
        SETTINGS_FINANCIAL,
        SETTINGS_PROFILE,
        SUBSCRIBERS,
        SUBSCRIPTIONS,
        CONTACT_US,
        PAYMENTS,
        ADD_CARD,
        CHOOSE_ARTWORK,
        SEARCH,
        SAVED_POSTS,
        EDIT_POST,
        TERMS_PRIVACY,
        SEND_MESSAGE,
        USER_PROFILE,
        ACCOUNT_SUPPORT,
        ACCOUNT_SECURITY_SUPPORT,
        GENERAL_QUESTIONS_SUPPORT,
        PRIVACY_TERMS_SUPPORT,
        SUBSCRIPTION_FAQ,
        PAYMENT_FAQ,
        TIPS_FAQ,
        MY_WALLET_FAQ,
        VALUE_TAX_FAQ,
        BECOME_CREATOR_SUPPORT,
        CREATOR_ERNING_PAYOUTS_SUPPORT,
        CREATOR_TIPS_SUPPORT,
        CREATOR_ACC_SUPPORT,
        CREATOR_ACC_SET_SUPPORT,
        CREATOR_TAG_SUPPORT,
        CREATOR_PROMOTING_SUPPORT,
        CREATOR_REF_SUPPORT,
        CREATOR_TECH_SUPPORT,
        CREATOR_VALUE_SUPPORT,
        CREATOR_TAX_INF_SUPPORT,
        QUESTION_SUPPORT,
        SEARCH_SUPPORT,
        MENUSETTINGS,
        CHANNELS,
        MEMBERS
      ],
    },
  };

  const middlePartOptions = {
    logo: {
      component: Logo,
      content: <img src={mainLogo} />,
      name: 'logo',
      icon: null,
      visibleOnScreens: [ROOT, SEARCH,SINGLE_POST],
    },
    tabName: {
      component: null,
      content: activeItem && activeItem.title,
      name: 'tab-name',
      icon: null,
      visibleOnScreens: [
        NOTIFICATIONS,
        MESSAGES,
        BOOKMARKS,
        HELP_SUPPORT,
        LIKEDPOSTS,
        LISTS,
        SETTINGS_FINANCIAL,
        SUBSCRIBERS,
        SUBSCRIPTIONS,
        CONTACT_US,
        PAYMENTS,
        ADD_CARD,
        CHOOSE_ARTWORK,
        SAVED_POSTS,
        TERMS_PRIVACY,
        ACCOUNT_SUPPORT,
        ACCOUNT_SECURITY_SUPPORT,
        GENERAL_QUESTIONS_SUPPORT,
        PRIVACY_TERMS_SUPPORT,
        SUBSCRIPTION_FAQ,
        PAYMENT_FAQ,
        TIPS_FAQ,
        MY_WALLET_FAQ,
        VALUE_TAX_FAQ,
        BECOME_CREATOR_SUPPORT,
        CREATOR_ERNING_PAYOUTS_SUPPORT,
        CREATOR_TIPS_SUPPORT,
        CREATOR_ACC_SUPPORT,
        CREATOR_ACC_SET_SUPPORT,
        CREATOR_TAG_SUPPORT,
        CREATOR_PROMOTING_SUPPORT,
        CREATOR_REF_SUPPORT,
        CREATOR_TECH_SUPPORT,
        CREATOR_VALUE_SUPPORT,
        CREATOR_TAX_INF_SUPPORT,
        QUESTION_SUPPORT,
        SEARCH_SUPPORT,
        MENUSETTINGS,
        CHANNELS,
        MEMBERS
      ],
    },
    userName: {
      component: null,
      content: user && `@${user.userName ? user.userName : user.name}`,
      name: 'user-name',
      icon: null,
      visibleOnScreens: [PROFILE, ADD_POST, EDIT_POST, SEND_MESSAGE, USER_PROFILE],
    },
    custom: {
      component: null,
      content: activeItem && activeItem.title,
      name: 'custom-title',
      icon: null,
      visibleOnScreens: [SETTINGS_ACCOUNT, SETTINGS_PROFILE],
    },
  };

  const renderLeftPart = () => {
    let leftPartContent = '';
    leftPartContent = Object.values(leftPartOptions)
      .filter(item => item.visibleOnScreens.includes(currentLocation))
      .map((Item, index) => {
        return (
          <div
            key={index}
            className={`${Item.name}-container`}
            onClick={Item.clickHandler ? clickHandler : null}>
            <Item.component />
          </div>
        );
      });

    return leftPartContent;
  };

  const renderRightPart = () => {
    let rightPartContent = '';
    rightPartContent = Object.values(rightPartOptions)
      .filter(item => item.visibleOnScreens.includes(currentLocation))
      .map((Item, index) => {
        return (
          <div key={index} className={`${Item.name}-container`}>
            <Item.component />
          </div>
        );
      });

    return rightPartContent;
  };

  const renderMiddlePart = () => {
    let middlePartContent = '';

    middlePartContent = Object.values(middlePartOptions)
      .filter(item => item.visibleOnScreens.includes(currentLocation))
      .map((Item, index) => {
        return (
          <div key={index} className={`${Item.name}-container`} >
            {Item.content && Item.content }
            {/* {Item.component ? <Item.component /> : Item.content} */}
          </div>
        );
      });
    return middlePartContent;
  };
  return (
    <div className="header" style={{ display: !!user ? 'block' : 'none' }}>
      <div className="d-flex justify-content-between align-items-center offset-side-menu header-content">
        <div className="d-flex header-left-container overflow-hidden px-4">{renderLeftPart()}</div>
        <div className="d-flex justify-content-center align-items-center header-middle-container overflow-hidden w-50" id={(currentLocation.includes('add_card') || currentLocation.includes('payments')) ? 'card-header' : ''}>
          {renderMiddlePart()}
        </div>
        <div className="d-flex header-right-container px-4" >
        </div>
      </div>
    </div>
  );
};

export default Header;
